import { GqlFieldworkerPreferredTransportationMethod } from "~/__generated__";

export const DEFAULT_TRAVEL_METHODS: GqlFieldworkerPreferredTransportationMethod[] = [
    GqlFieldworkerPreferredTransportationMethod.PrivateCar,
    GqlFieldworkerPreferredTransportationMethod.MyWheels,
    GqlFieldworkerPreferredTransportationMethod.Bike,
];

export const LONG_BIKE_ROUTE_THRESHOLD_SECONDS = 30 * 60;

/**
 * Type guard to check if a string is a valid GqlFieldworkerPreferredTransportationMethod
 * @param value - The string value to validate
 * @returns True if the value is a valid travel method, with type narrowing
 */
export function isValidTravelMethod(value: string): value is GqlFieldworkerPreferredTransportationMethod {
    return Object.values(GqlFieldworkerPreferredTransportationMethod).includes(
        value as GqlFieldworkerPreferredTransportationMethod,
    );
}
